export default __webpack_public_path__ + "static/media/introductory_image.4f318aa8.svg";